/**
 * 2D plans are organized into layers
 */
export class DsMapLayer {
  public id: number | null;

  public title: string;

  /**
   * Creates an instance of DsMapLayer.
   *
   * @param id the map layer id
   * @param title the map layer title
   */
  constructor(id: number | null, title: string) {
    this.id = id;
    this.title = title;
  }
}
